export const LOGIN_HEADER = "Log in";
export const LOGIN_DESCRIPTION = '"Your health is just a tap away." - log in now.';
export const FOGET_PASSWORD_HEADER = "Forgot Password?";
export const FOGET_PASSWORD_DESCRIPTION = "Please enter your email address to reset your password.";
export const RESET_PASSWORD_HEADER = "Reset Password!";
export const RESET_PASSWORD_DESCRIPTION = "Change your password now to keep your account secure.";
export const CHANGE_PASSWORD_HEADER = "Change Password";
export const MY_PROFILE_HEADER = "My Profile";
export const PATIENT_LIST_HEADER = "Patient List";
export const PROFILE_HEADER = "Profile";
export const PATIENT_DETAILS_HEADER = "Patient Details";
export const PATIENT_PROFILE_HEADER = "Patient Profile";
export const MY_TASKS_DETAIL = "My Tasks";
export const ASSIGN_TASKS = "Assign Tasks";
export const EDIT_TASK = "Edit Task";
export const ADD_HOSPITAL = "Add Hospital";
export const EDIT_HOSPITAL = "Edit Hospital";
export const HOSPITAL_DETAILS = "Hospital Details";
export const HOSPITAL_LIST = "Hospital list";
export const ROLE_LIST = "Role List";
export const ADD_ROLE = "Add Role";
export const VIEW_ROLE = "View Role";
export const EDIT_ROLE = "Edit Role";
export const ADD_PATIENT = "Add Patient";
export const TASK_LIST = "Task List";
export const STAFF_DETAIL = "Staff Detail";
export const ADD_PROFILE = "Add Profile";
export const DASHBOARD = "Dashboard";
export const STAFF_LIST = "Staff List";
export const Search = "Search";